// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","title":"title-qH39G","text":"text-m4keO","button":"button-ZNM5x"};